if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
document.addEventListener('DOMContentLoaded', () => {
  const currentInput = document.getElementById('current-level');
  const tierMsg = document.getElementById('tier-message');
  const tierExplain = document.getElementById('tier-explanation');

  // Only run on the Modded Trophy product
  if (!currentInput || !tierMsg) return;

  const radiosRoot = document.querySelector('variant-radios');
  if (!radiosRoot) return;

  // Level = option index 0, Starting Tier = option index 1
  const levelFieldset = radiosRoot.querySelector('fieldset[data-option-index="0"]');
  const tierFieldset  = radiosRoot.querySelector('fieldset[data-option-index="1"]');
  const addBtn        = document.querySelector('button.product-form__submit');

  if (!levelFieldset || !tierFieldset || !addBtn) return;

  const levelRadios  = Array.from(levelFieldset.querySelectorAll('input[type="radio"]'));
  const levelLabels  = levelRadios.map(r => r.closest('label') || r.parentElement);
  const tierRadios   = Array.from(tierFieldset.querySelectorAll('input[type="radio"]'));

  // Hide the "Starting Tier" UI row – we’ll control it via JS
  tierFieldset.style.display = 'none';

  // Initially lock everything until current level is entered
  levelRadios.forEach(r => r.disabled = true);
  addBtn.disabled = true;
  tierMsg.textContent = 'Enter your current trophy level to unlock available upgrades.';
  tierMsg.classList.remove('error');

  function scrollToInput() {
    currentInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  // Map level → Starting Tier option label (must match your option2 values)
  function getTierLabel(level) {
    const n = Number(level);
    if (n < 222)  return 'Below Tier 1 (<222)';
    if (n <= 333) return 'Tier 1 (222–333)';
    if (n <= 500) return 'Tier 2 (400–500)';
    if (n <= 666) return 'Tier 3 (555–666)';
    if (n <= 800) return 'Tier 4 (700–800)';
    // 801–998 treated as Tier 5 for pricing
    return 'Tier 5 (888–900)';
  }

  function updateExplanation(tierLabel) {
    const map = {
      'Below Tier 1 (<222)': 'Below Tier 1: every level shown is a full purchase.',
      'Tier 1 (222–333)':    'Tier 1: $5 for upgrades within this tier. Higher tiers subtract the Tier 1 price.',
      'Tier 2 (400–500)':    'Tier 2: $5 for upgrades within this tier. Higher tiers subtract the Tier 2 price.',
      'Tier 3 (555–666)':    'Tier 3: $5 for upgrades within this tier. Higher tiers subtract the Tier 3 price.',
      'Tier 4 (700–800)':    'Tier 4: $5 for upgrades within this tier. Higher tiers subtract the Tier 4 price.',
      'Tier 5 (888–900)':    'Tier 5: $5 upgrades within this tier.'
    };
    if (tierExplain) tierExplain.textContent = map[tierLabel] || '';
  }

  function selectTierRadio(label) {
    const radio = tierRadios.find(r => r.value === label);
    if (!radio) return;
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // Show only levels ABOVE the customer’s current level
  function updateLevelOptions(currentLevel) {
  let anySelectable = false;

  levelRadios.forEach((radio, idx) => {
    const labelEl = levelLabels[idx];
    const targetLevel = parseInt(radio.value, 10);

    if (Number.isNaN(targetLevel)) return;

    if (targetLevel <= currentLevel) {
      // Disable + grey out + strike through
      radio.disabled = true;
      labelEl.classList.add('psna-level-disabled');
      radio.checked = false;
    } else {
      // Make selectable
      radio.disabled = false;
      labelEl.classList.remove('psna-level-disabled');
      anySelectable = true;
    }
  });

  if (!anySelectable) {
    tierMsg.textContent = 'You are already higher than every level we offer.';
    tierMsg.classList.add('error');
    addBtn.disabled = true;
  }

  return anySelectable;
}


  currentInput.addEventListener('input', () => {
    const value = currentInput.value.trim();
    const level = Number(value);

    tierMsg.classList.remove('error');

    // Invalid or empty – lock everything
    if (!value || !Number.isFinite(level) || level < 1 || level > 998) {
      tierMsg.textContent = 'Enter a valid level between 1 and 998.';
      tierMsg.classList.add('error');
      addBtn.disabled = true;
      levelRadios.forEach(r => r.disabled = true);
      levelLabels.forEach(l => l.classList.remove('psna-level-hidden'));
      scrollToInput();
      return;
    }

    // Valid level – unlock, detect tier, filter targets
    levelRadios.forEach(r => r.disabled = false);

    const tierLabel = getTierLabel(level);
    tierMsg.textContent = `Detected tier: ${tierLabel}. Choose your new trophy level above your current level.`;
    updateExplanation(tierLabel);
    selectTierRadio(tierLabel);

    const hasOptions = updateLevelOptions(level);
    addBtn.disabled = !hasOptions;

    if (hasOptions) {
      // Auto-select first visible higher level
      const firstVisible = levelRadios.find((r, idx) => !levelLabels[idx].classList.contains('psna-level-hidden'));
      if (firstVisible) {
        firstVisible.checked = true;
        firstVisible.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else {
      scrollToInput();
    }
  });

  // Nudge them to start at the top of the flow
  scrollToInput();
});
